import cover2 from "../gallery/cover_2.jpg";
import cover3 from "../gallery/cover_3.jpg";
import cover4 from "../gallery/cover_4.jpg";

export const site = {
    name: "MJ Carpentry and Joinery",
    phone: "0451 160 499",
    phoneHref: "tel:+61451160499",
    email: "mjcarpentrysales@outlook.com",
    abn: "85 667 346 652",
    license: "451640C",
    // Web3Forms access key: quote requests are emailed to the address this key was created with.
    // Get one free at https://web3forms.com (enter the email above, the key arrives by email).
    // It is safe to keep in frontend code - it can only send to that inbox.
    quoteFormKey: "9709b1a6-dc1d-4a60-b591-c3bbf9a51303",
};

// Home page slider. `position` is the CSS background-position used to frame each photo.
export const heroSlides = [
    {
        image: cover3,
        position: "center 40%",
        title: "Custom doors, windows & joinery",
        description: "More than 20 years of experience providing highly qualified and licensed carpentry services.",
    },
    {
        image: cover4,
        position: "center 60%",
        title: "Let us build your vision, one nail at a time",
        description: "We craft masterpieces through custom designs and flawless finishes.",
    },
    {
        image: cover2,
        position: "center 45%",
        title: "Door and window furniture and hardware",
        description: "Fire door and fire door hardware installation, shelving, window sills and more.",
    },
];

export const reasons = [
    {value: "20+", label: "Years of experience"},
    {value: "Licensed", label: `Licence No. ${site.license}`},
    {value: "Custom", label: "Made to measure"},
    {value: "Free", label: "Estimate & quote"},
];

export const services = [
    "Second fix, finishing carpentry services, skirtings, architraves (mouldings)",
    "Internal and external doors and door jambs",
    "Door and window furniture and hardware",
    "Pivot door systems",
    "Sliding timber and aluminium doors installation",
    "Bi-fold timber and aluminium doors installation",
    "Timber and aluminium windows: bi-fold, awning, sliding installation",
    "Double glazing window and door systems",
    "Window and door gasket sealing systems",
    "Shelving and window sills",
    "Cabinetry installations",
    "Wardrobe installations",
    "Timber stair case construction and installation",
    "Customised bespoke joinery",
    "Timber balustrading and hand-rails",
    "Decking installation",
    "Pergola erection",
    "Fire door and fire door hardware installation",
    "Timber wall panelling and wainscotting, picture framing",
    "Partition walling, wall cladding",
    "Frameless and framed mirror installation",
    "Floating laminate floor laying",
    "Architectural feature carpentry and joinery",
].sort((a, b) => a.localeCompare(b, "en", {sensitivity: "base"}));

export const steps = [
    {
        title: "Request a free quote",
        description: "We ask a few questions to find out how we can help, then book you in for an appointment. You will receive a confirmation and a reminder close to the time.",
    },
    {
        title: "Place your order",
        description: "Once we have finished measuring your project, we provide a quote. Lead time to installation is typically between 2 and 3 weeks.",
    },
    {
        title: "Check measure",
        description: "Your installer visits to double check measurements and confirm job details. A deposit gets your job underway and the materials ordered, and we book a mutually agreeable installation date.",
    },
    {
        title: "Manufacture",
        description: "Your products are made to measure in our Sydney factory. A further deposit is needed once the product is delivered to the work site.",
    },
    {
        title: "Installation",
        description: "Your products are professionally fitted by our installers and we clean up thoroughly. Final payment is due on completion.",
    },
];

// Photos shown in the "Recent projects" strip on the home page.
export const featuredPhotos = [
    "pivotdoor_12.jpg",
    "slidingdoor_17.jpg",
    "staircase_3.jpg",
    "double_soft_sec_5.jpg",
    "timber_bifold.jpg",
    "alfresco_3.jpg",
    "shop_front_3.jpg",
    "entrancedoor_2.jpg",
];
